module.exports = __webpack_public_path__ + "img/44.bbc57e6f.jpg";